export default __webpack_public_path__ + "static/media/check-gray.f9866337.svg";